<template>
  <div v-if="thisReady" id="emrstatPage">
    <div v-if="invalidUser" class="noExam emrfont">Invalid<br>User</div>
    <div v-else-if="hasExam" class="hasExam emrfont">
      {{this.exTotal}} Total<br> {{this.exToday}} Today
    </div>
    <div v-else class="noExam emrfont">No Exams<br>Found</div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  name: "emrstat",
  data() {
    return {
      searchParams: this.$route.query,
      exTotal:0,
      exToday: 0,
      invalidUser: false,
      thisReady: false
    };
  },
  methods: {
    ...mapActions(["emrStatLogin", "getEMRStat"]),
    startupTask() {
      return this.emrStatLogin(this.$route.query).catch(() =>{
        this.invalidUser = true;
      });
    }
  },
  computed:{
    hasExam(){
      return this.exTotal > 0;
    }
  },
  created() {
    return this.startupTask()
      .then(() => {
          let params = {};
          let keys = Object.keys(this.searchParams);
          let key;
          for (let i = 0; i < keys.length; i++){
            key = keys[i];
            if (this.searchParams[key])
              params[key.toLowerCase()] = decodeURIComponent(this.searchParams[key]);
          }
          return this.getEMRStat(params).then(response =>{
            this.exTotal = response.data.data.exTotal;
            this.exToday = response.data.data.exToday;
          })   
      })
      .finally(() =>{
        this.thisReady = true;
      });
    }
  }
</script>

<style lang="scss">
  html{
    height: 40px !important;
    width: 70px !important;
    background: #FFFFFF;
  }
  .v-application--wrap{
    min-height: 0 !important;
  }
  #emrstatPage{
    text-align: center;
    height: 40px !important;
    width: 70px !important;
    .emrfont{    
      font-family: verdana;
      font-size: 12px;
      color: #FFFFFF;
      font-weight: bold;
      padding: 2px 1px;
    }
    .hasExam{
      background-color: #008000;
    }
    .noExam{
      background-color: #0000ff;
    }
  }
</style>